import { BoxTitles } from "@boxes/BoxTitles";
import { BaseCurrencyInput, Button, Drawer, Radio } from "@components";
import { useEffect, useState } from "react";

import styles from "@styles/forms-flow/filtered-audience.module.scss";

export const DaysWithoutConversionFilterForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const [controllerInputs, setControllerInputs] = useState(getInputType(node));

  const [min, setMin] = useState(node.data.min || null);
  const [max, setMax] = useState(node.data.max || null);
  const [exact, setExact] = useState(node.data.exact || null);

  const getFreshNode = () => {
    const dataValue = { ...(node?.data || {}), min, max, exact };

    switch (controllerInputs) {
      case "range":
        dataValue.exact = undefined;
        break;
      case "minimum":
        dataValue.exact = undefined;
        dataValue.max = undefined;
        break;
      case "exact":
        dataValue.min = undefined;
        dataValue.max = undefined;
        break;
    }

    dataValue.inLast = undefined;
    dataValue.inLastPeriod = undefined;

    return {
      ...node,
      data: dataValue,
    };
  };

  useEffect(() => {
    onChange && onChange(getFreshNode());
  }, [min, max, exact]);

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={BoxTitles.DaysWithoutConversionFilter}
    >
      <p className={styles.label}>Defina a quantidade de dias sem pedir</p>

      <Radio
        text="Faixa de dias sem pedir"
        family="DaysWithoutConversion"
        className="mb-15"
        value="range"
        checked={controllerInputs}
        onChange={() => setControllerInputs("range")}
      />

      {controllerInputs === "range" && (
        <div className="mb-20 d-flex align-center">
          <BaseCurrencyInput
            className="w-100 mr-15"
            value={min}
            precision={0}
            prefix=""
            suffix=" dias"
            onChange={(v) => setMin(v)}
          />
          <BaseCurrencyInput
            className="w-100"
            value={max}
            precision={0}
            prefix=""
            suffix=" dias"
            onChange={(v) => setMax(v)}
          />
        </div>
      )}

      <Radio
        text="Mínimo de dias sem pedir"
        family="DaysWithoutConversion"
        className="mb-15"
        value="minimum"
        checked={controllerInputs}
        onChange={() => setControllerInputs("minimum")}
      />

      {controllerInputs === "minimum" && (
        <BaseCurrencyInput
          className="mb-20 w-100"
          value={min}
          precision={0}
          prefix=""
          suffix=" dias"
          onChange={(v) => setMin(v)}
        />
      )}

      <Radio
        text="Dias sem pedir exato"
        family="DaysWithoutConversion"
        className="mb-15"
        value="exact"
        checked={controllerInputs}
        onChange={() => setControllerInputs("exact")}
      />

      {controllerInputs === "exact" && (
        <BaseCurrencyInput
          className="mt-20 w-100"
          value={exact}
          precision={0}
          prefix=""
          suffix=" dias"
          onChange={(v) => setExact(v)}
        />
      )}

      <div className={styles.footer}>
        <Button
          design="primary"
          className="w-100"
          onClick={() => onSave(getFreshNode())}
        >
          Salvar
        </Button>
      </div>
    </Drawer>
  );
};

const getInputType = (node) => {
  const { data } = node || {};
  if (data?.exact !== null && data?.exact !== undefined) {
    return "exact";
  } else if (data?.max !== null && data?.max !== undefined) {
    return "range";
  } else if (data?.min !== null && data?.min !== undefined) {
    return "minimum";
  } else {
    return "range";
  }
};
